module.exports = __webpack_public_path__ + "static/Strategy_and_Consulting-7c77ed6e15400f36a3fd603b33d93d59.svg";